import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import {  Navigate } from 'react-router-dom';
import ReimbursementStore from '../stores/ReimbursementStore';
import withNavigate from '../../Common/components/withNavigate';
import Message from '../../Common/components/Message';
import messageStore from '../../Common/stores/messageStore';

@observer
class ConfirmationScreen extends Component {


  componentDidMount () {
    // Navigate to landing page on browser tab back-button/arrow click on confirmation page
    window.addEventListener("popstate", this.goToHome);
    // Navigate to landing page on browser tab refresh on confirmation page
    if (!ReimbursementStore.confirmationId) {
      this.goToHome();
    }

    if (window.performance) {
      if (performance.navigation.type == 1) {
          const contextPath = window.location.pathname;
          window.location.href = contextPath;
      }
    }
  }

  // This method is called when a component is being removed from the DOM
  componentWillUnmount = () => {
    window.removeEventListener("popstate", this.goToHome);
  }

  goToHome = () => {
    ReimbursementStore.clearReimbursementForm();
    const { navigate } = this.props;
    navigate('/');
  }

  printPage = () => {
    const buttonElements = document.getElementsByTagName('button');

    // hiding Buttons while printing
    [...buttonElements].forEach(buttonElement => {
      buttonElement.classList.add('printing');
    })

    window.print();

    // un-hiding Buttons while printing
    [...buttonElements].forEach(buttonElement => {
      buttonElement.classList.remove('printing');
    })

  };


  render() {
    const { submitSuccess, confirmationId } = ReimbursementStore;

    return (
      <>
        <div className="border-form">
          {submitSuccess ?
            <>
              <Row className="custom-box">
                <Col>
                  <div className="center-text">
                    <i className="icon icon-ok-circle check-icon" />
                  </div>
                  <div className="spacer" />
                  {/* <div className="center-text poppinsH5-Confirmation">
                    TAP Reimbursement Request Form Submitted
                  </div>
                  <div className="spacer" />
                  <h5 className="center-text confirmationTitle poppinsH5-ThankYouNote">
                    The FCS TAP Reimbursement Request Form has been successfully submitted. We are currently processing
                    your request and will notify you within five business days with the status of the reimbursement request.
                  </h5>
                  <div className="spacer" /> */}
                  <div className="center-text poppinsH5-Confirmation">
                    Confirmation: <b>{confirmationId}</b>
                  </div>
                  <div className="spacer" />
                  <h5 className="center-text poppinsH5-ThankYouNote">
                    Your request has been successfully submitted. If you have questions please email us at<br/><a href={`mailto:TransitionAssistanceFCS@wellpoint.com`}>TransitionAssistanceFCS@wellpoint.com</a> or call 1-844-451-2828.
                  </h5>
                  <div className="spacer" />
                  <div className="d-flex flex-row justify-content-center">
                    {/* <Button type="button" color="link" className="btn btn-link printBtn" onClick={this.printPage}>
                      <i className="icon icon-print" />
                      Print Confirmation Number
                    </Button> */}

                    <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"} onClick={this.goToHome}>
                      Submit Another FCS TAP Request
                    </Button>
                  </div>
                </Col>
              </Row>
            </>
            :
            <Message messageStore={messageStore} />
          }
        </div>
        <div className="pb-spacerRem-10" />
      </>
    );
  }
}
export default withNavigate(ConfirmationScreen);

ConfirmationScreen.propTypes = {
  navigate: PropTypes.func
};